{
  "alert": "Advarsel",
  "dismiss": "Luk"
}
